import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import {
  addNewConnection,
  removeFromConnection,
} from "../../actions/connectionActions";
import Badges from "../../components/Badges";
import Mission from "../../components/Mission";
import Overview from "../../components/Overview";
import ProfileProjects from "../../components/ProfileProjects";
import connections from "../../utils/connections.json";
import "./Profile.css";

const Profile = ({ location }) => {
  const [follow, setFollow] = useState(false);
  const { connections: allConnections } = useSelector(
    (state) => state.connection
  );
  const { mode } = useSelector((state) => state.mode);
  const userInfo =
    localStorage.getItem("gsprklUserInfo") &&
    JSON.parse(localStorage.getItem("gsprklUserInfo"));

  let { profile, id } = useParams();
  const userProfile = connections.find(
    (connection) =>
      connection.id === id ||
      connection.connection.username.split("/")[1] === id
  );
  const connected = allConnections.find((c) => userProfile?.id === c?.id);
  const [tab, setTab] = useState(userProfile ? "connect" : "lobby");
  const teacherMode =
    mode === "teacher" || mode === "learning" || mode === "teaching";
  const teacher = profile === "t" || teacherMode;
  const dispatch = useDispatch();

  const handleChangeImage = async (e) => {
    // for send image profile
    const file = e.target.files[0];
    const bodyFormData = new FormData();
    bodyFormData.append("image", file);
    try {
      // for later to send to the backend
      // const { data } = await Axios.post("", bodyFormData, {
      //   headers: {
      //     "Content-Type": "multipart/form-data",
      //     Authorization: `Bearer ${aboutUser.token}`,
      //   },
      // });
      // setLoadingUpload(true);
      // setImage(data);
      // setLoadingUpload(false);
    } catch (err) {
      // setLoadingUpload(true);
      // setErrorUpload(err.message);
      // setLoadingUpload(false);
    }
  };

  const handleCopy = (e) => {
    let text = `https://app.geniusparkle.com/${e.target.innerText}`;
    if (!navigator.clipboard) {
      // use old execCommand() way
      let textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.append(textArea);
      textArea.select();
      document.execCommand("copy"); //No i18n
      document.body.removeChild(textArea);
    } else {
      navigator.clipboard.writeText(text);
    }
  };

  const handleFollowConnection = () => {
    setTab("connect");
    if (connected || follow) {
      setFollow(false);
      dispatch(removeFromConnection(userProfile.id));
    } else {
      setFollow(true);
      dispatch(addNewConnection(userProfile));
    }
  };

  useEffect(() => {
    if (location.search) {
      setTab(location.search.substr(1));
    }
  }, [location]);

  return (
    <div className={`profileContent ${tab}`}>
      <div>
        <div className="profileContent__img">
          <div className="profileContent__badges flex-row">
            {!teacher && (
              <>
                <img
                  src={`/images/badges/${
                    userProfile
                      ? userProfile.plan
                      : userInfo?.plan
                      ? userInfo?.plan
                      : "free-plan"
                  }.png`}
                  alt={
                    userProfile
                      ? userProfile.plan
                      : userInfo?.plan
                      ? userInfo?.plan
                      : "free-plan"
                  }
                />
                <img
                  src={`/images/badges/${
                    userProfile ? userProfile.level : "radiant"
                  }.png`}
                  alt={userProfile ? userProfile.level : "radiant"}
                />
              </>
            )}
          </div>
          <span className="profileContent__teacherHashtag">
            {profile === "t"
              ? teacherMode
                ? "#ShapeTheFuture"
                : "#ShapingTheFuture"
              : ""}
          </span>
          <img
            src={
              teacher
                ? "https://images.unsplash.com/photo-1451187580459-43490279c0fa?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1472&q=80"
                : "https://images.unsplash.com/photo-1526786220381-1d21eedf92bf?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1470&q=80"
            }
            alt=""
          />
        </div>
        <div className="profileContent__profile flex-row">
          <div className="flex-row">
            <div className="profileContent__profileMainImg">
              <img
                src={
                  userProfile
                    ? userProfile.connection.img
                    : "https://images.unsplash.com/photo-1554126807-6b10f6f6692a?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=870&q=80"
                }
                alt=""
                className="profileContent__profileImg"
              />
              <div
                className={`profileContent__imgOverlay ${
                  userProfile && "hidden"
                }`}
              >
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 48 48"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M28.7 6C30.64 6.01998 32.22 7.01887 33.14 8.81687C33.3775 9.29134 33.7088 9.98432 34.0556 10.7153L34.4744 11.5993L34.68 12.0333L34.88 12.4728C34.96 12.6127 35.1 12.7125 35.28 12.7125C40.08 12.7125 44 16.6282 44 21.4229V33.2897C44 38.0844 40.08 42 35.28 42H12.72C7.9 42 4 38.0844 4 33.2897V21.4229C4 16.6282 7.9 12.7125 12.72 12.7125C12.88 12.7125 13.04 12.6326 13.1 12.4728L13.22 12.2331C13.78 11.0544 14.46 9.61598 14.86 8.81687C15.78 7.01887 17.34 6.01998 19.28 6H28.7ZM24 18.8058C21.9 18.8058 19.92 19.6249 18.42 21.1232C16.94 22.6215 16.12 24.5794 16.14 26.657C16.14 28.7547 16.96 30.7125 18.44 32.2109C19.94 33.6892 21.9 34.5083 24 34.5083C26.16 34.5083 28.12 33.6293 29.54 32.2109C30.96 30.7925 31.84 28.8346 31.86 26.657C31.86 24.5794 31.04 22.6016 29.56 21.1032C28.08 19.6249 26.1 18.8058 24 18.8058ZM24 21.8024C25.3 21.8024 26.52 22.3019 27.44 23.2209C28.36 24.1398 28.86 25.3585 28.86 26.657C28.84 29.3341 26.68 31.5117 24 31.5117C22.7 31.5117 21.48 31.0122 20.56 30.0932C19.64 29.1743 19.14 27.9556 19.14 26.657V26.6371C19.12 25.3785 19.62 24.1598 20.54 23.2408C21.48 22.3019 22.7 21.8024 24 21.8024ZM35.22 18.3263C34.22 18.3263 33.42 19.1454 33.42 20.1443C33.42 21.1432 34.22 21.9423 35.22 21.9423C36.22 21.9423 37.04 21.1432 37.04 20.1443C37.04 19.1454 36.22 18.3263 35.22 18.3263Z" />
                </svg>
                <input
                  type="file"
                  className="profileContent__imgOverlayImgInput"
                  accept="image/*"
                  onChange={handleChangeImage}
                />
              </div>
            </div>
            <div className="profileContent__profileDetails flex-column">
              <h3>
                {userProfile ? userProfile.connection.name : "Abraham Benjamin"}{" "}
              </h3>
              <span className="flex-row" onClick={handleCopy}>
                <svg
                  viewBox="0 0 18 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15 3.8125H6C4.89543 3.8125 4 4.65197 4 5.6875V14.125C4 15.1605 4.89543 16 6 16H15C16.1046 16 17 15.1605 17 14.125V5.6875C17 4.65197 16.1046 3.8125 15 3.8125Z"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M4 13.1875H2.84615C2.35652 13.1875 1.88695 12.99 1.54073 12.6383C1.1945 12.2867 1 11.8098 1 11.3125V2.875C1 2.37772 1.1945 1.90081 1.54073 1.54917C1.88695 1.19754 2.35652 1 2.84615 1H11.1538C11.6435 1 12.1131 1.19754 12.4593 1.54917C12.8055 1.90081 13 2.37772 13 2.875V3.8125"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M11.4545 8.5H12.4091C12.618 8.5 12.8249 8.53858 13.0179 8.61353C13.2109 8.68849 13.3863 8.79835 13.534 8.93684C13.6818 9.07534 13.7989 9.23976 13.8789 9.42071C13.9588 9.60167 14 9.79561 14 9.99148C14 10.1873 13.9588 10.3813 13.8789 10.5622C13.7989 10.7432 13.6818 10.9076 13.534 11.0461C13.3863 11.1846 13.2109 11.2945 13.0179 11.3694C12.8249 11.4444 12.618 11.483 12.4091 11.483H11.4545M9.54545 11.483H8.59091C8.38199 11.483 8.17511 11.4444 7.98209 11.3694C7.78908 11.2945 7.6137 11.1846 7.46597 11.0461C7.16761 10.7664 7 10.387 7 9.99148C7 9.59591 7.16761 9.21655 7.46597 8.93684C7.76432 8.65714 8.16897 8.5 8.59091 8.5H9.54545"
                    stroke="black"
                    strokeWidth="0.848485"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M9.22754 9.99121H11.773"
                    stroke="black"
                    strokeWidth="0.848485"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>

                {userProfile
                  ? userProfile.connection.username
                  : "g/abrahambenjamin"}
              </span>
            </div>
          </div>
          {userProfile ? (
            <ul className="flex-row">
              <li
                className={`flex-row ${tab === "connect" && "active"} ${
                  (follow || connected) && "followed"
                }`}
                onClick={handleFollowConnection}
              >
                <svg viewBox="0 0 49 49" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.0269 29.4376L20.2652 29.4377L20.7931 29.4391C25.277 29.4631 35.7809 29.8707 35.7809 36.7996C35.7809 43.2238 27.1541 44.0823 20.4438 44.1146L19.2608 44.1141C14.7769 44.0902 4.27295 43.6827 4.27295 36.7556C4.27295 30.1956 13.2629 29.4376 20.0269 29.4376ZM20.0269 32.4376C11.5649 32.4376 7.27295 33.8916 7.27295 36.7556C7.27295 39.6476 11.5649 41.1156 20.0269 41.1156C28.4889 41.1156 32.7809 39.6616 32.7809 36.7996C32.7809 33.9036 28.4889 32.4376 20.0269 32.4376ZM38.6811 16.363C39.5091 16.363 40.1811 17.035 40.1811 17.863L40.181 20.3716L42.7729 20.3732C43.6009 20.3732 44.2729 21.0452 44.2729 21.8732C44.2729 22.7012 43.6009 23.3732 42.7729 23.3732L40.181 23.3716L40.1811 25.885C40.1811 26.713 39.5091 27.385 38.6811 27.385C37.8531 27.385 37.1811 26.713 37.1811 25.885L37.181 23.3716L34.5929 23.3732C33.7649 23.3732 33.0929 22.7012 33.0929 21.8732C33.0929 21.0452 33.7649 20.3732 34.5929 20.3732L37.181 20.3716L37.1811 17.863C37.1811 17.035 37.8531 16.363 38.6811 16.363ZM20.0269 4.52563C25.8929 4.52563 30.6629 9.29763 30.6629 15.1616C30.6629 21.0256 25.8929 25.7976 20.0269 25.7976H19.9649C17.1269 25.7876 14.4669 24.6736 12.4729 22.6656C10.4769 20.6556 9.38295 17.9876 9.39288 15.1556C9.39288 9.29764 14.1629 4.52563 20.0269 4.52563ZM20.0269 7.52563C15.8189 7.52563 12.3929 10.9516 12.3929 15.1616C12.3849 17.1996 13.1689 19.1096 14.5989 20.5516C16.0309 21.9916 17.9389 22.7896 19.9709 22.7976L20.0269 24.2796V22.7976C24.2369 22.7976 27.6629 19.3716 27.6629 15.1616C27.6629 10.9516 24.2369 7.52563 20.0269 7.52563Z"
                  />
                </svg>

                <p>
                  {follow || connected
                    ? `${
                        userProfile.identity.job === "Genius"
                          ? "Connected"
                          : "Following"
                      }`
                    : `${
                        userProfile.identity.job === "Genius"
                          ? "Connect"
                          : "Follow"
                      }`}
                </p>
              </li>
              <li
                className={`flex-row ${
                  tab === "message" && "active"
                } message-tab-profile`}
                onClick={() => setTab("message")}
              >
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M18.9185 20.2173L18.9185 20.2173C18.7281 20.2961 18.4884 20.3464 18.1006 20.3728C17.7074 20.3997 17.2071 20.4 16.5 20.4H12C7.36081 20.4 3.6 16.6392 3.6 12C3.6 7.36081 7.36081 3.6 12 3.6C16.6392 3.6 20.4 7.36081 20.4 12V16.5C20.4 17.2071 20.3997 17.7074 20.3728 18.1006C20.3464 18.4884 20.2961 18.7281 20.2173 18.9185L20.2173 18.9185C19.9738 19.5065 19.5065 19.9738 18.9185 20.2173Z"
                    stroke="#4D4F5C"
                    strokeWidth="1.5"
                  />
                  <path d="M9 11H15" strokeWidth="1.5" strokeLinecap="round" />
                  <path d="M12 15H15" strokeWidth="1.5" strokeLinecap="round" />
                </svg>

                <p>Message</p>
              </li>
            </ul>
          ) : (
            <ul className="flex-row">
              <li
                className={`flex-row ${tab === "lobby" && "active"}`}
                onClick={() => setTab("lobby")}
              >
                <svg viewBox="0 0 49 49" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M34.4889 4.17157C39.3669 4.17157 43.3389 8.14157 43.3389 13.0216V35.2996C43.3389 40.1916 39.3569 44.1716 34.4669 44.1716H24.6969C19.8189 44.1716 15.8489 40.2016 15.8489 35.3216V33.4376C15.8489 32.6096 16.5209 31.9376 17.3489 31.9376C18.1769 31.9376 18.8489 32.6096 18.8489 33.4376V35.3216C18.8489 38.5456 21.4729 41.1716 24.6969 41.1716H34.4669C37.7049 41.1716 40.3389 38.5396 40.3389 35.2996V13.0216C40.3389 9.79757 37.7129 7.17157 34.4889 7.17157H24.7189C21.4829 7.17157 18.8489 9.80357 18.8489 13.0396V14.9056C18.8489 15.7336 18.1769 16.4056 17.3489 16.4056C16.5209 16.4056 15.8489 15.7336 15.8489 14.9056V13.0396C15.8489 8.14957 19.8289 4.17157 24.7189 4.17157H34.4889ZM27.1675 17.2776L33.0254 23.1111C33.0729 23.1586 33.1173 23.2093 33.1581 23.2628L33.0255 23.1096C33.1054 23.1883 33.1753 23.2753 33.2345 23.3684C33.2466 23.3918 33.2603 23.4146 33.2733 23.4378C33.2961 23.4736 33.3155 23.5117 33.3331 23.5505C33.3431 23.578 33.3546 23.6053 33.3653 23.6331C33.3824 23.6711 33.3956 23.7102 33.4071 23.7498C33.4139 23.781 33.4219 23.8121 33.4289 23.8436C33.4398 23.8817 33.4469 23.9201 33.4524 23.9587C33.4524 23.9763 33.4547 23.9948 33.4567 24.0133C33.4647 24.0661 33.4675 24.1187 33.4675 24.1716L33.4529 24.3296L33.4512 24.375C33.4508 24.3784 33.4503 24.3818 33.4498 24.3852L33.4675 24.1716C33.4675 24.2826 33.4552 24.3925 33.4313 24.4994C33.4219 24.5311 33.4139 24.5622 33.4049 24.5929C33.3956 24.6329 33.3823 24.672 33.3676 24.7105C33.3546 24.7378 33.3431 24.7652 33.3308 24.7921C33.3155 24.8315 33.2961 24.8695 33.2752 24.9067C33.2603 24.9285 33.2466 24.9514 33.2324 24.9738C33.2109 25.0119 33.1855 25.0481 33.1585 25.0832C33.14 25.104 33.1229 25.1252 33.1051 25.146C33.0811 25.1765 33.0539 25.2056 33.0255 25.2336L27.1675 31.0636C26.8755 31.3556 26.4915 31.5016 26.1095 31.5016C25.7255 31.5016 25.3395 31.3556 25.0475 31.0596C24.4615 30.4716 24.4655 29.5236 25.0515 28.9396L28.3329 25.6716H7.88293C7.05493 25.6716 6.38293 24.9996 6.38293 24.1716C6.38293 23.3436 7.05493 22.6716 7.88293 22.6716H28.3329L25.0515 19.4016C24.4655 18.8176 24.4615 17.8696 25.0475 17.2816C25.6335 16.6936 26.5815 16.6936 27.1675 17.2776Z"
                  />
                </svg>

                <p>The Lobby</p>
              </li>
              <li
                className={`flex-row ${tab === "missions" && "active"}`}
                onClick={() => setTab("missions")}
              >
                <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M24.4998 8C24.3178 8 23.8698 8.05 23.6318 8.526L19.9798 15.828C19.4018 16.982 18.2878 17.784 16.9998 17.968L8.82383 19.146C8.28383 19.224 8.09983 19.624 8.04383 19.792C7.99383 19.954 7.91383 20.366 8.28583 20.722L14.1978 26.402C15.1398 27.308 15.5678 28.614 15.3438 29.892L13.9518 37.912C13.8658 38.414 14.1798 38.706 14.3198 38.806C14.4678 38.918 14.8638 39.14 15.3538 38.884L22.6638 35.094C23.8158 34.5 25.1878 34.5 26.3358 35.094L33.6438 38.882C34.1358 39.136 34.5318 38.914 34.6818 38.806C34.8218 38.706 35.1358 38.414 35.0498 37.912L33.6538 29.892C33.4298 28.614 33.8578 27.308 34.7998 26.402L40.7118 20.722C41.0858 20.366 41.0058 19.952 40.9538 19.792C40.8998 19.624 40.7158 19.224 40.1758 19.146L31.9998 17.968C30.7138 17.784 29.5998 16.982 29.0218 15.826L25.3658 8.526C25.1298 8.05 24.6818 8 24.4998 8ZM14.8938 42C14.0678 42 13.2478 41.74 12.5458 41.228C11.3338 40.34 10.7398 38.874 10.9978 37.398L12.3898 29.378C12.4418 29.08 12.3398 28.778 12.1198 28.566L6.20783 22.886C5.11983 21.844 4.72983 20.304 5.18983 18.874C5.65383 17.428 6.88183 16.394 8.39583 16.178L16.5718 15C16.8878 14.956 17.1598 14.762 17.2958 14.486L20.9498 7.182C21.6238 5.836 22.9838 5 24.4998 5C26.0158 5 27.3758 5.836 28.0498 7.182L31.7058 14.484C31.8438 14.762 32.1138 14.956 32.4278 15L40.6038 16.178C42.1178 16.394 43.3458 17.428 43.8098 18.874C44.2698 20.304 43.8778 21.844 42.7898 22.886L36.8778 28.566C36.6578 28.778 36.5578 29.08 36.6098 29.376L38.0038 37.398C38.2598 38.876 37.6658 40.342 36.4518 41.228C35.2218 42.13 33.6198 42.252 32.2618 41.544L24.9558 37.758C24.6698 37.61 24.3278 37.61 24.0418 37.758L16.7358 41.546C16.1518 41.85 15.5218 42 14.8938 42Z"
                  />
                </svg>

                <p>Missions</p>
              </li>
              <li
                className={`flex-row ${tab === "statistics" && "active"}`}
                onClick={() => setTab("statistics")}
              >
                <svg viewBox="0 0 49 49" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.294 11.4069C21.16 12.0869 21.658 13.1009 21.658 14.1889C21.658 22.9589 21.954 25.3189 23.164 26.2169C23.958 26.8029 25.046 26.7969 28.712 26.6949C30.416 26.6449 32.598 26.5809 35.456 26.5809C36.596 26.5809 37.67 27.0689 38.398 27.9189C39.074 28.7089 39.37 29.7409 39.214 30.7569C37.878 39.4069 30.518 45.6889 21.714 45.6889C11.946 45.6889 4 37.7429 4 27.9769C4 20.2329 9.856 12.4889 17.054 10.7169C18.178 10.4429 19.386 10.6989 20.294 11.4069ZM17.964 13.6069C17.9 13.6069 17.836 13.6149 17.772 13.6309C11.832 15.0929 7 21.5289 7 27.9769C7 36.0889 13.6 42.6889 21.714 42.6889C29.028 42.6889 35.14 37.4789 36.248 30.2989C36.256 30.2389 36.284 30.0649 36.12 29.8709C35.964 29.6889 35.716 29.5809 35.456 29.5809C32.634 29.5809 30.48 29.6449 28.798 29.6929C24.726 29.8149 23.042 29.8609 21.378 28.6269C18.9986 26.8642 18.6858 23.9008 18.66 15.585L18.658 14.1889C18.658 14.0209 18.586 13.8809 18.442 13.7689C18.308 13.6629 18.138 13.6069 17.964 13.6069ZM40.1008 8.46748C43.6168 11.9815 45.8488 16.5995 45.7848 20.2335C45.7608 21.6515 44.7308 22.8355 43.3388 23.0455C40.6228 23.4555 37.4428 23.5795 34.6288 23.5795C32.0088 23.5795 29.7028 23.4735 28.3768 23.3975C26.7088 23.2995 25.3808 21.9695 25.2848 20.3015C25.1288 17.6575 24.7908 10.9395 25.0308 5.74348C25.0968 4.23348 26.3168 3.03148 27.8088 3.00548C32.0828 2.88148 36.4928 4.86548 40.1008 8.46748ZM28.0648 6.00348H28.0208C27.8008 11.0415 28.1268 17.5495 28.2788 20.1275C28.2868 20.2815 28.3988 20.3935 28.5508 20.4015C30.6068 20.5195 37.6908 20.8475 42.7849 20.0975C42.7968 17.2895 40.8748 13.4815 37.9808 10.5895C35.0128 7.62548 31.5008 6.00348 28.0648 6.00348Z"
                  />
                </svg>

                <p>Statistics</p>
              </li>
              <li
                className={`flex-row ${tab === "projects" && "active"}`}
                onClick={() => setTab("projects")}
              >
                <svg
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M27.9511 4.00049C28.037 4.00049 28.1212 4.00772 28.2032 4.02161L28.4769 4.02329C28.8849 4.02329 29.2749 4.18929 29.5589 4.48329L39.6889 15.0373C39.9569 15.3153 40.1072 15.6893 40.1072 16.0753V34.4073C40.1429 39.4253 36.2349 43.5253 31.2089 43.7293L15.1709 43.7313H14.9529C10.053 43.6205 6.12325 39.6577 6.00353 34.8056L6.00293 12.9813C6.11893 8.01929 10.2169 4.02329 15.1429 4.02329L27.699 4.02161C27.781 4.00772 27.8652 4.00049 27.9511 4.00049ZM26.4509 7.02249L15.1469 7.02329C11.8329 7.02329 9.08093 9.70729 9.00293 13.0173V34.4073C8.92893 37.8333 11.6289 40.6553 15.0209 40.7313H31.1489C34.4869 40.5933 37.1309 37.8193 37.1071 34.4193L37.1069 17.9665L33.0871 17.9685C29.4271 17.9585 26.4511 14.9745 26.4511 11.3185L26.4509 7.02249ZM27.5775 29.2167C28.4055 29.2167 29.0775 29.8887 29.0775 30.7167C29.0775 31.5447 28.4055 32.2167 27.5775 32.2167H16.7775C15.9495 32.2167 15.2775 31.5447 15.2775 30.7167C15.2775 29.8887 15.9495 29.2167 16.7775 29.2167H27.5775ZM23.4877 21.7127C24.3157 21.7127 24.9877 22.3847 24.9877 23.2127C24.9877 24.0407 24.3157 24.7127 23.4877 24.7127H16.7757C15.9477 24.7127 15.2757 24.0407 15.2757 23.2127C15.2757 22.3847 15.9477 21.7127 16.7757 21.7127H23.4877ZM29.4509 8.70449L29.4511 11.3185C29.4511 13.3265 31.0851 14.9625 33.0911 14.9685L35.4629 14.9665L29.4509 8.70449Z"
                  />
                </svg>

                <p>Projects</p>
              </li>
            </ul>
          )}
        </div>
      </div>
      {profile === "g" && <Badges />}
      {/* {teacher && <RatingOverviewCard />} */}
      {tab === "lobby" && <Overview setTab={setTab} />}
      {tab === "missions" && <Mission />}
      {/* {tab === "statistics" && <Dashboard />} */}
      {(tab === "projects" || userProfile) && (
        <ProfileProjects userProfile={userProfile} setTab={setTab} />
      )}
    </div>
  );
};

export default Profile;
